export const filterBySelectedDomain = (data, selectedDomain) => {
  const result = data.filter(dataItem => dataItem.domainName === selectedDomain)
  return result
}
